import type { NewsFeedCommonModel } from '@app/models/api/NewsFeed';
import type { Notifications } from '@app/models/app/NotificationsModel';
import { getUserAccountNotifications } from '@app/services/api/notifications';
import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';

export const userAccountNotifications: Writable<Notifications | null> = writable(null);
export const unreadNewsfeedItems: Writable<NewsFeedCommonModel[]> = writable([]);
export const unreadNotifications: Writable<number> = writable(0);
export async function updateNotificationStore(data: any) {
	const {
		user,
		conversions,
		pendingSubscriptionsToSign,
		pendingSubscriptionsToPay,
		newsfeed,
		pollsNotifications,
		generalAssembliesNotifications
	} = data;

	const notifications = await getUserAccountNotifications(
		user,
		conversions,
		pendingSubscriptionsToSign,
		pendingSubscriptionsToPay,
		pollsNotifications,
		generalAssembliesNotifications
	);

	userAccountNotifications.set(notifications);
	unreadNewsfeedItems.set(newsfeed.filter((news: NewsFeedCommonModel) => !news.seen));
	unreadNotifications.set(
		notifications.length + newsfeed.filter((news: NewsFeedCommonModel) => !news.seen).length
	);
}
